import { Box, useTheme } from "@vapor/react-material";
import { useTranslation } from "react-i18next";

import dayjs from "dayjs";
import type {
    Action,
    ActionType,
} from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { DetailRow } from "../TaxSubmissionDetailSummary";

interface TaxSubmissionActionProps {
    action: Action;
}

const ACTION_TYPE_TRANSLATIONS: Record<ActionType, string> = {
    SEND_AWAITING:
        "views.home.components.tax_submission_detail_summary.action.send_awaiting",
    SEND_REJECTED:
        "views.home.components.tax_submission_detail_summary.action.send_rejected",
    UPDATE_AGENCY_ID:
        "views.home.components.tax_submission_detail_summary.action.update_agency_id",
    UPDATE_DELEGATED:
        "views.home.components.tax_submission_detail_summary.action.update_delegated",
};

export const TaxSubmissionAction: React.FC<TaxSubmissionActionProps> = ({
    action,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const operator =
        action.operator.familyName || action.operator.givenName
            ? `${action.operator.givenName} ${action.operator.familyName}`
            : null;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                border: `1px solid ${theme.palette.primary.gainsboro}`,
                p: 0.5,
                backgroundColor: theme.palette.primary.background,
            }}
        >
            <DetailRow
                label={t(
                    "views.home.components.tax_submission_detail_summary.action.type",
                )}
                value={t(ACTION_TYPE_TRANSLATIONS[action.type])}
                divider={false}
            />
            <DetailRow
                label={t(
                    "views.home.components.tax_submission_detail_summary.action.operator",
                )}
                value={
                    operator
                        ? operator
                        : t(
                              "views.home.components.tax_submission_detail_summary.action.operator.no_data",
                          )
                }
                divider={false}
            />
            <DetailRow
                label={t(
                    "views.home.components.tax_submission_detail_summary.action.date",
                )}
                value={dayjs(action.date).format("DD/MM/YYYY - HH:mm")}
                divider={false}
            />
        </Box>
    );
};
